module.exports = __webpack_public_path__ + "img/circle-caret-down.8bd15415.svg";